<script setup lang="ts"></script>

<template>
  <div class="p-3 d-flex flex-column h-100">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Toolbox</h1>
    </div>
    <RouterView />
  </div>
</template>

<style scoped></style>
